import router from './routes'
import store from '../store'

// Check user is authorised before each route
router.beforeEach((to, from , next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['authStore/isLoggedIn']) {
      // Go to login
      next('/login')
    } else {
      next()
    }
    } else {
      next()
    }
})

export { router }
